module.exports = __webpack_public_path__ + "static/img/dfh.6281ad9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dfh.svg
// module id = LD89
// module chunks = 1 2